/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, LinearProgress } from '@material-ui/core'
import moment from 'moment-timezone'
import { FC, useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router'
import { Dispatch } from 'redux'
import { getApartmentByCode } from '../../actions/apartments'
import { createApplication, getApartmentLead } from '../../actions/applications'
import ChangeLanguageForm from '../../components/ChangeLanguageForm'
import Container from '../../components/Container'
import { selectApartmentByCode } from '../../selectors/apartments'
import {
  selectCreateApplication,
  selectLeadApplication
} from '../../selectors/applications'
import i18n from '../../translations/i18n'
import { Apartment } from '../../types/apartments'
import { Application, PartnerLead } from '../../types/applications'
import { StateInterface, LocationInterface } from '../../types/states';
// import { bindSubmitActionToPromise } from '../../utils/forms'
import NewApplicationForm, { isOneAdult } from './NewApplicationForm'
import NewApplicationProgress from './Progress'

const App: FC = (props: any) => {
  const history = useHistory()

  const routeMatch = useRouteMatch()

  const step = Number.parseInt((routeMatch.params as any).step || 0)
  const initialValue = {
    firstName: '',
    lastName: '',
    email: '',
    phone: { phone: '358', countryDialCode: '358' },
    availabilities: [{ startDate: moment() }],
    notes: '',
    contactInformationConsent: false,
    marketingConsent: false
  }
  const [value, setValue] = useState(initialValue)
  const [applicationId, setApplicationId] = useState('')

  const navigateTo = useCallback(
    (newStep) => {
      history.push(
        `/new-application/${(routeMatch.params as any).apartmentCode
        }/steps/${newStep}`
      )
    },
    [history, routeMatch]
  )

  useEffect(() => {
    props.getApartmentByCode((routeMatch.params as any).apartmentCode)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const qs = new URLSearchParams(props.location.search)
    if (qs && qs.get('source')) {
      props.getLeadData(qs.get('source'))
    }
  }, [])

  useEffect(() => {
    if (props.lead && props.lead.leadData && props.lead.leadData.metadata) {
      const leadData = props.lead.leadData.metadata
      const updatedValue = {
        ...initialValue,
        firstName: leadData.name.split(' ')[0] || '',
        lastName: leadData.name.split(' ')[1] || '',
        email: leadData.email || '',
        notes: leadData.notes || ''
      }
      if (leadData.phone && leadData.phone.trim()) {
        updatedValue.phone = { countryDialCode: '358', phone: leadData.phone }
      }
      setValue(updatedValue)
      setApplicationId(props.lead.leadData.applicationId)
    }
  }, [props.lead])

  return (
    <>
      {props.apartmentByCode?.address ? (
        <>
          <Container
            styles={{ maxWidth: '1131px', margin: 'auto', padding: '8px 20px' }}
          >
            <NewApplicationProgress
              progress={step === 0 ? 33 : ((step + 1) / 4) * 100}
            />
          </Container>

          <ChangeLanguageForm
            go={(arg: any) => {
              navigateTo(step);
            }}
            isApplication={true}
            style={{
              right: window.innerWidth < 300 ? '3px' : window.innerWidth < 600 ? '5px' : '15px',
              transform: 'none',
              marginLeft: 'auto',
              position: 'absolute',
            }}
          />
          <Grid container justify='center'>
            {!props.application && (
              <NewApplicationForm
                onSubmit={(_values: any) => {
                  if (
                    step === 0 ||
                    step === 1 ||
                    (step === 2 && !isOneAdult(_values))
                  ) {
                    navigateTo(step + 1)
                  } else {
                    props.createApplication({
                      ..._values,
                      apartmentCode: (routeMatch.params as any).apartmentCode,
                      language: i18n.language,
                      applicationId: applicationId
                    })
                  }
                }}
                back={() => {
                  navigateTo(step - 1)
                }}
                step={step}
                initialValues={{ ...value }}
              />
            )}
          </Grid>
        </>
      ) : (
        <LinearProgress />
      )}
    </>
  )
}

interface PropsFromState {
  loading: boolean
  application: Application | null
  error: string | null
  apartmentByCode: Apartment | null
  lead: PartnerLead | null
}

const mapStateToProps = (state: StateInterface): PropsFromState => {
  const createApplication = selectCreateApplication(state)
  const getLeadApplication = selectLeadApplication(state)
  const apartmentByCode = selectApartmentByCode(state)
  return {
    ...createApplication,
    ...getLeadApplication,
    apartmentByCode
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createApplication: (data: any) => dispatch(createApplication(data)), // bindSubmitActionToPromise(dispatch, createApplication)
  getApartmentByCode: (apartmentCode: string) =>
    dispatch(getApartmentByCode(apartmentCode)),
  getLeadData: (leadId: string) => dispatch(getApartmentLead(leadId))
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
